/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const LeadDescription = {
  LEAD_ASSIGNED: (_n?: Notification) => 'A new Lead is assigned to you.',
  LEAD_REMOVED_ASSIGNED: (_n?: Notification) =>
    'A Lead has been unassigned from you.',
};

const LeadLogs = {
  LEAD_ASSIGNED: {
    title: 'Lead Assigned',
    description: (_n?: Notification) => LeadDescription.LEAD_ASSIGNED(_n),
    element: ({ actor, meta, referenceId }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/contact/leads/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/contact/leads/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const lead = useMemo(() => meta?.fullName ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {LeadDescription['LEAD_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Lead Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={lead}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
  LEAD_REMOVED_ASSIGNED: {
    title: 'Lead Assigned Removed',
    description: (_n?: Notification) =>
      LeadDescription.LEAD_REMOVED_ASSIGNED(_n),
    element: ({ referenceId, meta, actor }: Notification) => {
      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (actor?.role === 'account') return `/contact/leads/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/contact/leads/${referenceId}`;
      }, [actor, accountId, accountUserId, referenceId]);

      const lead = useMemo(() => meta?.fullName ?? '', [meta]);

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {LeadDescription['LEAD_REMOVED_ASSIGNED']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Lead Name:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={lead}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default LeadLogs;
